import "./App.css";
import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

const frontImagesContext = require.context(
  "./images/front",
  false,
  /\.(png|jpe?g|svg)$/
);
const frontImages = frontImagesContext.keys().map(frontImagesContext);
const backImagesContext = require.context(
  "./images/back",
  false,
  /\.(png|jpe?g|svg)$/
);
const backImages = backImagesContext.keys().map(backImagesContext);
const toolsImagesContext = require.context(
  "./images/tools",
  false,
  /\.(png|jpe?g|svg)$/
);
const toolsImages = toolsImagesContext.keys().map(toolsImagesContext);

function App() {
  useEffect(() => {
    AOS.init();
  }, []);

  return (
    <div className="App">
      <section
        id="hero"
        className="hero text-center py-5"
        data-aos="fade-up"
        data-aos-delay="500"
      >
        <div className="container">
          <h2 className="display-4">NEGRE FLORIAN</h2>
          <p className="lead">
            Développeur Web et Web Mobile (DWWM){" "}
            <strong>Titre RNCP:37674</strong> .
          </p>
        </div>
      </section>

      <section
        id="about"
        className="py-5 bg-light"
        data-aos="fade-up"
        data-aos-delay="1500"
      >
        <div className="container">
          <h2 className="text-center mb-4">À propos de moi</h2>
          {/* <p className='text-center'></p> */}
          <p className="text-center">
            Après dix ans dans la restauration, j'ai choisi de me réorienter
            vers le développement web et web mobile. Ayant terminé ma formation
            de Développeur Web, j'ai acquis de bonnes bases en HTML, CSS,
            JavaScript, PHP, SQL, REACT & Symfony. <br />
            J'ai réalisé mon projet de formation fullstack visibles sur ce lien
            :{" "}
            <a className="fw-semibold " href="https://canopee-2.3d-pixel.fr/">
              Mon Projet
            </a>{" "}
            , ainsi que sur mon{" "}
            <a href="https://Github.com/NgrFlorian">GitHub</a> et mon{" "}
            <a href="https://Linkedin.com/in/florian-negre-dev">Linkedin</a>.
          </p>
        </div>
      </section>

      <section
        id="skills"
        className="py-5"
        data-aos="fade-up"
        data-aos-delay="2000"
      >
        <div className="container">
          <h2 className="text-center mb-4">Mes Compétences de Devs</h2>
          <div className="row">
            <div className="col-md-4 mb-4">
              <div className="card h-100" data-aos="fade-up">
                <div className="card-body">
                  <h3 className="card-title">Front-End</h3>
                  <ul className="list-unstyled">
                    <li>HTML5</li>
                    <li>CSS3 / Sass / Bootstrap 5</li>
                    <li>JavaScript</li>
                    <li>React</li>
                    <li>VueJs</li>
                  </ul>
                  <div className="banner-container">
                    <div className="scrolling-banner">
                      {frontImages.concat(frontImages).map((img, index) => (
                        <img
                          key={index}
                          src={img}
                          alt={`Front ${index}`}
                          className="banner-image"
                        />
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-4 mb-4">
              <div
                className="card h-100"
                data-aos="fade-up"
                data-aos-delay="100"
              >
                <div className="card-body">
                  <h3 className="card-title">Back-End</h3>
                  <ul className="list-unstyled">
                    <li>PHP</li>
                    <li>Symfony</li>
                    <li>SQL</li>
                    <li>MySQL</li>
                    <li>API REST</li>
                  </ul>
                  <div className="banner-container">
                    <div className="scrolling-banner">
                      {backImages.concat(backImages).map((img, index) => (
                        <img
                          key={index}
                          src={img}
                          alt={`Back ${index}`}
                          className="banner-image"
                        />
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-4 mb-4">
              <div
                className="card h-100"
                data-aos="fade-up"
                data-aos-delay="200"
              >
                <div className="card-body">
                  <h3 className="card-title">Outils</h3>
                  <ul className="list-unstyled">
                    <li>Git</li>
                    <li>VS Code</li>
                    <li>Figma</li>
                    <li>Postman</li>
                    <li>Docker</li>
                  </ul>
                  <div className="banner-container">
                    <div className="scrolling-banner">
                      {toolsImages.concat(toolsImages).map((img, index) => (
                        <img
                          key={index}
                          src={img}
                          alt={`Tools ${index}`}
                          className="banner-image"
                        />
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section
        id="projects"
        className="py-5 bg-light"
        data-aos="fade-up"
        data-aos-delay="300"
      >
        <div className="container">
          <h2 className="text-center mb-4">Mes Projets</h2>
          <div className="row">
            <div className="col-md-6 mb-4">
              <div className="card h-100" data-aos="fade-up">
                <a href="https://3d-pixel.fr/" className="card-body">
                  <h3 className="card-title">eShop (bientôt)</h3>
                  <p className="card-text">
                    Application e-commerce développée avec React et Symfony.
                    Fonctionnalités incluant panier, paiement, gestion des
                    produits.
                  </p>
                </a>
              </div>
            </div>
            <div className="col-md-6 mb-4">
              <div
                className="card h-100"
                data-aos="fade-up"
                data-aos-delay="100"
              >
                <a
                  href="https://canopee-2.3d-pixel.fr/"
                  className="card-body"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <h3 className="card-title">Canopee</h3>
                  <p className="card-text">
                    Plateforme de présentation et de contact avec React et
                    Symfony. Interface admin moderne pour la gestion de données
                    de texte et d'images en Base de données.
                  </p>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section
        id="contact"
        className="py-5"
        data-aos="fade-up"
        data-aos-delay="400"
      >
        <div className="container text-center">
          <h2 className="mb-4">Contact</h2>
          <p>
            Email:{" "}
            <a href="mailto:NgrFlorian@gmail.com">NgrFlorian@gmail.com</a>
          </p>
          <p>
            LinkedIn:{" "}
            <a
              href="https://linkedin.com/in/florian-negre-dev"
              target="_blank"
              rel="noopener noreferrer"
            >
              Linkedin.com/in/florian-negre-dev
            </a>
          </p>
        </div>
      </section>
    </div>
  );
}

export default App;
